import { Component, HostBinding, HostListener, Input } from '@angular/core';

import { GridConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { StringDictionary } from '@frontend/sports/common/core/utils/extended-types';
import { GridEvent } from '@frontend/sports/grid/core/feature/model';
import { DeviceService } from '@frontend/vanilla/core';

import { RedirectHelperService } from '../../navigation-core/redirect-helper.service';

@Component({
    selector: 'ms-event-footer',
    templateUrl: 'event-footer.component.html',
    styleUrls: ['./event-footer.component.scss'],
    standalone: false,
})
export class EventFooterComponent {
    @Input() event: GridEvent;
    @Input() eventUrl: string;
    @Input() mediaEnabled: boolean;
    @Input() promotedFixtureIdsMap: StringDictionary<string> = {};
    @Input() showEventTimerInfoSection?: boolean;
    @Input() showFixedFooterSection?: boolean;
    @Input() isGameNotesVisible = false;
    @Input() gameNotes?: string;
    @HostBinding('class') className = 'footer-event';

    constructor(
        public sitecore: Sitecore,
        private deviceService: DeviceService,
        private redirectHelper: RedirectHelperService,
        public gridConfig: GridConfig,
    ) {}

    get isMobilePhone(): boolean {
        return this.deviceService.isMobilePhone;
    }

    @HostListener('click')
    eventClick(): void {
        this.redirectHelper.goToPage(this.eventUrl);
    }
}
